
import { Component, Vue } from "vue-property-decorator"
import { PortalTarget, Wormhole } from "portal-vue"

import { CasesPortalNames } from "@/views/new/Cases.vue"

// Suffixes the case details portals so the title, subheader and buttons land in this window's
// own chrome instead of the main page shell's.
const restrictedPortalId = "restricted"

@Component({
	components: {
		"case-details": () => import("@/components/New/Cases/CaseDetails.vue"),
		"portal-target": PortalTarget
	}
})
export default class RestrictedCaseDetails extends Vue {
	public beforeDestroy (): void {
		window.close()
	}

	public get portalId (): string {
		return restrictedPortalId
	}

	public get caseNumber (): string | null {
		return this.$route?.params?.caseNumber ?? null
	}

	public get headerPortal (): string {
		return `${CasesPortalNames.HeaderContent}-${restrictedPortalId}`
	}

	public get subHeaderPortal (): string {
		return `${CasesPortalNames.SubHeader}-${restrictedPortalId}`
	}

	public get footerRightPortal (): string {
		return `${CasesPortalNames.FooterRight}-${restrictedPortalId}`
	}

	private get hasHeaderContent (): boolean {
		return Wormhole.hasContentFor(this.headerPortal)
	}

	private get hasSubHeaderContent (): boolean {
		return Wormhole.hasContentFor(this.subHeaderPortal)
	}

	private get hasFooterContent (): boolean {
		return Wormhole.hasContentFor(this.footerRightPortal)
	}
}
